import { ICategory, IKeyword, IkeywordsByType } from 'types';

export const generateCategoryKeywords = (category: ICategory, checkedOnly = false): number[] => {
    const categoryKeywords: number[] = [];
    if (category.keywords) {
        if (!checkedOnly || (checkedOnly && category.checked)) {
            category.keywords.forEach((keyword) => {
                if (!categoryKeywords.includes(keyword)) categoryKeywords.push(keyword);
            });
        }
    } else if (category.subRows) {
        category.subRows.forEach((cat) => {
            const subcategoryKeywords = generateCategoryKeywords(cat, checkedOnly);
            if (subcategoryKeywords) {
                subcategoryKeywords.forEach((keyword) => {
                    if (!categoryKeywords.includes(keyword)) categoryKeywords.push(keyword);
                });
            }
        });
    }
    return categoryKeywords;
};

export const generateCategoriesKeywords = (categories: ICategory[], checkedOnly = false): number[] => {
    const categoryKeywords: number[] = [];
    categories.forEach((category) => {
        const categoryKeywordsIds = generateCategoryKeywords(category, checkedOnly);
        categoryKeywordsIds.forEach((keywordId) => {
            if (!categoryKeywords.includes(keywordId)) categoryKeywords.push(keywordId);
        });
    });
    return categoryKeywords;
};

export const getSelectedSegments = (category: ICategory[]): ICategory[] => {
    const segments: ICategory[] = [];
    category.forEach((cat) => {
        if (cat.level === 'segment' && cat.checked) {
            segments.push(cat);
        } else if (cat.subRows) {
            const subSegments = getSelectedSegments(cat.subRows);
            if (subSegments.length) segments.push(...subSegments);
        }
    });
    return segments;
};

export const getCheckedKeywordsIds = (keywords: IkeywordsByType[]): number[] => {
    const checkedKeywords: number[] = [];
    keywords.forEach((keyword) => {
        keyword.keywords.forEach((k) => {
            if (k.checked) checkedKeywords.push(Number(k.id));
        });
    });
    return checkedKeywords;
};

export const getKeywordNames = (keywords: IKeyword[] | undefined, keywordIds: number[]): string[] => {
    const keywordNames: string[] = [];
    keywordIds.forEach((keywordId) => {
        const keyword = keywords?.find((k) => k.keyword_id === keywordId);
        if (keyword) keywordNames.push(keyword.name);
    });
    return keywordNames;
};
